import { useContext, useMemo } from 'react';

import './styles.scss';
import PricingGroup from '../../../../components/pricing-group';
import { PricingContext } from '../../../../providers/pricing-provider';

const PricingAndRisk = () => {
  const { trades, getTradeResult } = useContext(PricingContext);

  const getAllRiskKeys = useMemo(() => {
    const keysSet = new Set<string>();
    trades.forEach((trade) => {
      const result = getTradeResult(trade.id);

      if (result?.risk?.display) {
        Object.keys(result?.risk?.display).forEach((key) => keysSet.add(key));
      } else {
        ['pv', 'delta', 'gamma', 'theta', 'vega'].forEach((key) => keysSet.add(key));
      }
    });
    return Array.from(keysSet).filter((key) => key !== 'ladder');
  }, [trades, getTradeResult]);

  const ITEMS = useMemo(() => {
    const riskItems = getAllRiskKeys.map((key) => ({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1),
    }));
    return [...riskItems];
  }, [getAllRiskKeys]);

  const formatValue = (value: any): string => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'number') {
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 6,
      });
    }
    return String(value);
  };

  const getValue = (tradeId: string, key: string): string => {
    const result = getTradeResult(tradeId);

    const risk = result?.risk;

    if (risk?.display) {
      if (key === 'pv') {
        return formatValue(risk.display.pv);
      }
      return formatValue(risk.display[key]);
    }

    if (risk) {
      if (key === 'pv') {
        if (result?.pv) {
          return formatValue(result.pv);
        }

        return '-';
      }

      return formatValue(risk[key]);
    }
    return '-';
  };

  return (
    <div className="pricing-data">
      <PricingGroup label={'Pricing and risk'} isClosable defaultOpen={true}>
        <div className="pricing-data-container">
          <div className="fixed-panel">
            {ITEMS.map((item) => (
              <span className="item" key={item.key}>
                {item.key === 'pv' ? 'Price' : item.label}
              </span>
            ))}
          </div>
          <div className="content-panel">
            {trades.map((trade) => (
              <div key={trade.id} className="block">
                {ITEMS.map((item) => (
                  <div className="item-row" key={item.key}>
                    <span className="item-content">{getValue(trade.id, item.key)}</span>
                  </div>
                ))}
              </div>
            ))}
            <div className="block"></div>
          </div>
        </div>
      </PricingGroup>
    </div>
  );
};

export default PricingAndRisk;
